module.exports = {
  name: 'iemas',
  isSimplyBased: true,
  logo: 'iemas.svg',
  logo_text: 'Brought to you by',
  logo_link: 'https://www.iemasinsurancebrokers.co.za/',
  logo_fineprint: 'Iemas Insurance Brokers is a registered FSP (47563)',
  google_font: 'Lato',
  font_headings: 'Lato',
  margintop: '80px',
  font_body: '-apple-system,BlinkMacSystemFont,"Segoe UI",Roboto,Oxygen-Sans,Ubuntu,Cantarell,"Helvetica Neue",sans-serif',
  colours: {
    primary: {
      darkest: '#00a84f',
      darker: '#00a84f',
      dark: '#00a84f',
      base: '#00a84f',
      light: '#00a84f',
      lighter: '#00dd68',
      lightest: '#fff',
      light_text: '#fff',
      dark_text: '#2f3946',
      border_colour: 'transparent',
      gradient: 'linear-gradient(45deg, #00a84f 0%, #00a84f 100%);',
      gradient_hover: 'linear-gradient(45deg, #00a84f 0%, #00a84f 100%);'
    },
    secondary: {
      darkest: '#00a84f',
      darker: '#00a84f',
      dark: '#00a84f',
      base: '#00a84f',
      light: '#00a84f',
      lighter: '#00a84f',
      lightest: '#00a84f',
      light_text: '#fff',
      dark_text: '#2f3946',
      border_colour: 'transparent',
      gradient: 'linear-gradient(45deg, #00a84f 0%, #00a84f 100%);',
      gradient_hover: 'linear-gradient(45deg, #00a84f 0%, #00a84f 100%);'
    },
    tertiary: {
      darkest: '#00a84f',
      darker: '#00a84f',
      dark: '#00a84f',
      base: '#00a84f',
      light: '#00a84f',
      lighter: '#00a84f',
      lightest: '#00a84f',
      light_text: '#fff',
      dark_text: '#2f3946',
      border_colour: 'transparent',
      gradient: 'linear-gradient(45deg, #00a84f 0%, #00a84f 100%);',
      gradient_hover: 'linear-gradient(45deg, #00a84f 0%, #00a84f 100%);'
    },
    ghost: {
      darkest: 'transparent',
      darker: 'transparent',
      dark: 'transparent',
      base: 'transparent',
      light: 'transparent',
      lighter: 'transparent',
      lightest: 'transparent',
      light_text: '#00a84f',
      dark_text: '#2f3946',
      border_colour: '#00a84f',
      gradient: 'none',
      gradient_hover: 'none'
    },
    'ghost-secondary': {
      darkest: 'transparent',
      darker: 'transparent',
      dark: 'transparent',
      base: 'transparent',
      light: 'transparent',
      lighter: 'transparent',
      lightest: 'transparent',
      light_text: '#00a84f',
      dark_text: '#2f3946',
      border_colour: '#00a84f',
      gradient: 'none',
      gradient_hover: 'none'
    },
    'ghost-tertiary': {
      darkest: 'transparent',
      darker: 'transparent',
      dark: 'transparent',
      base: 'transparent',
      light: 'transparent',
      lighter: 'transparent',
      lightest: 'transparent',
      light_text: '#00a84f',
      dark_text: '#2f3946',
      border_colour: '#00a84f',
      gradient: 'none',
      gradient_hover: 'none'
    },
    filled: {
      darkest: '#fff',
      darker: '#fff',
      dark: '#fff',
      base: '#fff',
      light: '#fff',
      lighter: '#fff',
      lightest: '#fff',
      light_text: '#00a84f',
      dark_text: '#2f3946',
      border_colour: '#00a84f',
      gradient: 'none',
      gradient_hover: 'none'
    },
    neutral: {
      darkest: '#2F3946',
      darker: '#9d9fa1',
      dark: '#9d9fa1',
      base: '#d1d6da',
      light: '#E0E2E4',
      lighter: '#EAEBEC',
      lightest: '#fff',
      light_text: '#fff',
      dark_text: '#2f3946',
      border_colour: 'transparent',
      gradient: 'none',
      gradient_hover: 'none'
    },
    danger: {
      darkest: '#662222',
      darker: '#D94949',
      dark: '#D94949',
      base: '#FF5656',
      light: '#FF6F6F',
      lighter: '#FF9999',
      lightest: '#FFBBBB',
      light_text: '#fff',
      dark_text: '#662222',
      border_colour: 'transparent',
      gradient: 'none',
      gradient_hover: 'none'
    }
  }
};